export default __webpack_public_path__ + "static/media/reservas.30bfa6c5.png";